{
  "title": "Create Food and Water",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You create 45 pounds of food and 30 gallons of water on the ground or in containers within range, enough to sustain up to fifteen humanoids or five steeds for 24 hours. The food is bland but nourishing, and spoils if uneaten after 24 hours. The water is clean and doesn’t go bad."
  ],
  "spellLists": ["artificer", "cleric", "paladin"]
}
